/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateMaintenanceReportCommandResult } from '../../models/create-maintenance-report-command-result';
import { ReportDailyTaskVm } from '../../models/report-daily-task-vm';

export interface ApiProjectMaintenanceReportCreateProjectMaintenanceReportPost$Plain$Params {
      body?: {
'ProjectId'?: string;
'Notes'?: string;
'ReportDailyTasks'?: Array<ReportDailyTaskVm>;
'Attachments'?: Array<Blob>;
}
}

export function apiProjectMaintenanceReportCreateProjectMaintenanceReportPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectMaintenanceReportCreateProjectMaintenanceReportPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateMaintenanceReportCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectMaintenanceReportCreateProjectMaintenanceReportPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateMaintenanceReportCommandResult>;
    })
  );
}

apiProjectMaintenanceReportCreateProjectMaintenanceReportPost$Plain.PATH = '/api/ProjectMaintenanceReport/CreateProjectMaintenanceReport';
